import Api from './api'
import Auth from './auth'
import Quiz from './quiz'
import Admin from './admin'
import Squarespace from './squarespace'
import Subscription from './subscription'
import Curl from './curl'
import hairRegimen from './hairRegimen'

export default {
    Api,
    Auth,
    Quiz,
    Admin,
    Squarespace,
    Subscription,
    Curl,
    hairRegimen
}



// WEBPACK FOOTER //
// ./src/store/modules/index.js